module.exports = __webpack_public_path__ + "static/media/SmartNewLoading.5d8cf5ee.svg";